import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../Components/Layout/Layout";
import OgxHero from "../../Containers/OgxHero/OgxHero";
import OgxAbout from "../../Containers/OgxAbout/OgxAbout";
import OgxPrograms from "../../Containers/OgxPrograms/OgxPrograms";
import OgxNewsletter from "../../Containers/OgxNewsletter/OgxNewsletter";

const OgxPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>
          Go Global with AIESEC in Nigeria | Outgoing Global Exchange
        </title>
        <meta
          name="description"
          content="Explore verified internships, teaching placements, and social impact projects abroad with AIESEC in Nigeria's Outgoing Global Exchange (OGX)."
        />
      </Helmet>
      <OgxHero />
      <OgxAbout />
      <OgxPrograms />
      <OgxNewsletter />
    </Layout>
  );
};

export default OgxPage;
